import { CircleAlert } from 'lucide-react';

/** Fehler einer Anmeldefläche als Karte über dem Formular (Board A), vorgelesen als Warnung. */
export function AuthAlert({ title, text }: { title: string; text: string }) {
  return (
    <div
      role="alert"
      className="border-sealwax/30 bg-sealwax-tint rounded-tile flex items-start gap-3 border px-4 py-3.5"
    >
      <CircleAlert size={20} aria-hidden className="text-sealwax mt-px flex-none" />
      <p className="text-sm leading-relaxed">
        <b>{title}</b> {text}
      </p>
    </div>
  );
}
